export default {
  "mainVegetable": "darzeni",
  "mainVegetable/01": "darzeni/baklazans",
  "mainVegetable/02": "darzeni/spargelis",
  "mainVegetable/03": "darzeni/avokado",
  "mainVegetable/04": "darzeni/biete",
  "mainVegetable/05": "darzeni/brokolis",
  "mainVegetable/06": "darzeni/burkans",
  "mainVegetable/07": "darzeni/selerija",
  "mainVegetable/08": "darzeni/sampinjons",
  "mainVegetable/09": "darzeni/kaposts",
  "mainVegetable/10": "darzeni/brisels-kaposts",
  "mainVegetable/11": "darzeni/kinas-kaposts",
  "mainVegetable/12": "darzeni/ziedkaposts",
  "mainVegetable/13": "darzeni/coleslaw",
  "mainVegetable/14": "darzeni/gurkis",
  "mainVegetable/15": "darzeni/cukini",
  "mainVegetable/16": "darzeni/frise-salati",
  "mainVegetable/17": "darzeni/spinati",
  "mainVegetable/18": "darzeni/fava-pupinas",
  "mainVegetable/19": "darzeni/flageolet-pupinas",
  "mainVegetable/20": "darzeni/paksu-pupinas",
  "mainVegetable/21": "darzeni/liofilizetas-pupinas",
  "mainVegetable/22": "darzeni/zalas-paksu-pupinas",
  "mainVegetable/23": "darzeni/lecas",
  "mainVegetable/24": "darzeni/darzenu-maisijums",
  "mainVegetable/25": "darzeni/kukuruza",
  "mainVegetable/26": "darzeni/salati-mix",
  "mainVegetable/27": "darzeni/racenis",
  "mainVegetable/28": "darzeni/sipols",
  "mainVegetable/29": "darzeni/soya-pupinas",
  "mainVegetable/30": "darzeni/paprika",
  "mainVegetable/31": "darzeni/kartupelis",
  "mainVegetable/32": "darzeni/soya-pipinas-asni",
  "mainVegetable/33": "darzeni/redisi",
  "mainVegetable/34": "darzeni/ozollapu-salati",
  "mainVegetable/35": "darzeni/frisee-salati",
  "mainVegetable/36": "darzeni/iceberg-salati",
  "mainVegetable/37": "darzeni/piedmontese-salati",
  "mainVegetable/38": "darzeni/risu-darzeni",
  "mainVegetable/39": "darzeni/romiesu-salati",
  "mainVegetable/40": "darzeni/asni",
  "mainVegetable/41": "darzeni/salati",
  "mainVegetable/42": "darzeni/lamb-salati",
  "mainVegetable/43": "darzeni/rukola",
  "mainVegetable/44": "darzeni/pastinaki",
  "mainVegetable/45": "darzeni/taboule",
  "mainVegetable/46": "darzeni/tomats",
  "mainVegetable/47": "darzeni/sviesta-pupinas",
  "mainVegetable/48": "darzeni/turku-zirni",
  "mainVegetable/49": "darzeni/puravi",
  "mainVegetable/50": "darzeni/kirbis",
  "mainVegetable/51": "darzeni/sarkanas-pupinas",
  "mainVegetable/52": "darzeni/abols",
  "mainVegetable/53": "darzeni/kastanis",
  "mainVegetable/54": "darzeni/plume",
  "mainVegetable/55": "darzeni/gardener",
  "mainVegetable/56": "darzeni/melnas-olivas",
  "mainVegetable/57": "darzeni/artisoks",
  "mainVegetable/58": "darzeni/sarkana-paprika",
  "mainVegetable/59": "darzeni/zalas-pupinas",
  "mainVegetable/60": "darzeni/spring",
  "mainVegetable/61": "darzeni/sautejums",
  "mainVegetable/62": "darzeni/kuskuss",
  "mainVegetable/63": "darzeni/tadzina",
  "mainVegetable/64": "darzeni/curry-vegetables",
  "mainVegetable/65": "darzeni/pea-cups",
  "mainVegetable/66": "darzeni",
  "mainVegetable/67": "darzeni/korallu-lecas",
  "mainVegetable/68": "darzeni/kvinoja",
  "mainVegetable/69": "darzeni/spelta",
  "mainVegetable/70": "darzeni/bulgurs",
  "mainVegetable/71": "darzeni/sarkanais-kaposts",
  "mainVegetable/72": "darzeni/lapu-kaposts",
  "mainVegetable/73": "darzeni/petersilis",
  "mainVegetable/74": "darzeni/graudaugu-un-seklu",
  "mainVegetable/75": "darzeni/darzeni",
  "mainVegetable/76": "darzeni/saldais-kartupelis",
  "mainVegetable/77": "darzeni/kirbis",
  "mainVegetable/78": "darzeni/mikla",
  "mainVegetable/79": "darzeni/pupinas",
  "mainVegetable/80": "darzeni/zirni-burkans",
  "mainVegetable/81": "darzeni/zirni",
  "mainVegetable/82": "darzeni/edamame-pupinas",
  "mainVegetable/83": "darzeni/miezi",
  "mainVegetable/84": "darzeni/salatu-maisijums",
  "mainVegetable/85": "darzeni/sugar-loaf-chicory",
  "mainVegetable/86": "darzeni/lamb-lettuce",
  "mainVegetable/87": "darzeni/spinati",
  "mainVegetable/88": "darzeni/baby-green-batavia",
  "mainVegetable/89": "darzeni/swiss-chard",
  "mainVegetable/90": "darzeni",
  "mainVegetable/91": "darzeni",
  "mainVegetable/92": "darzeni",
  "mainVegetable/93": "darzeni",
  "mainVegetable/94": "darzeni",
  "mainVegetable/95": "darzeni",
  "mainVegetable/96": "darzeni",
  "mainVegetable/97": "darzeni",
  "mainVegetable/98": "darzeni",
  "season": "sezona",
  "season/1": "sezona/vasara",
  "season/2": "sezona/rudens",
  "season/3": "sezona/ziema",
  "season/4": "sezona/pavasaris",
  "season/5": "sezona",
  "technologie": "gatavosanas-veids",
  "technologie/AC01": "gatavosanas-veids/konservets",
  "technologie/AD01": "gatavosanas-veids/saldets",
  "technologie/AG01": "gatavosanas-veids/svaigi",
  "technologie/AT01": "gatavosanas-veids/caterer",
  "recipeDish": "ediens",
  "recipeDish/ACC": "ediens/piedevas",
  "recipeDish/APE": "ediens/piedevas",
  "recipeDish/DES": "ediens/deserts",
  "recipeDish/ENT": "ediens/uzkodas",
  "recipeDish/PLAT": "ediens/pamatedieniem",
  "recipeDish/SAL": "ediens/salati",
  "recipeDish/SNA": "ediens/uzkodas",
  "recipeDish/PDE": "ediens/brokastis",
  "recipeDish/DEJ": "ediens/pusdienas",
  "recipeDish/TRA": "ediens/tradicionali",
  "recipeDish/GOU": "ediens/gardeziem-uzkoda",
  "recipeDish/ETH": "ediens/tradicionali",
  "recipeDish/FCH": "ediens/berniem",
  "recipeDish/SOU": "ediens/zupas",
  "pred-recipeTimingCook-facet": "cepsanas-ilgums",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "cepsanas-ilgums/0-15-minutes",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "cepsanas-ilgums/15-30-minutes",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "cepsanas-ilgums/30-45-minutes",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "cepsanas-ilgums/45-minutes",
  "pred-recipeTimingPreparation-facet": "gatavosanas-ilgums",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "gatavosanas-ilgums/0-15-minutes",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "gatavosanas-ilgums/15-30-minutes",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "gatavosanas-ilgums/30-45-minutes",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "gatavosanas-ilgums/45-minutes",
  "pred-recipeCost-Facet": "cena",
  "pred-recipeCost-Facet/petit": "cena/lets",
  "pred-recipeCost-Facet/moyen": "cena/videji-dargs",
  "pred-recipeCost-Facet/grand": "cena/dargs",
  "recipeDifficulty": "gatavosana",
  "recipeDifficulty/1": "gatavosana/vienkarss",
  "recipeDifficulty/2": "gatavosana/videji-sarezgits",
  "recipeDifficulty/3": "gatavosana/sarezgits",
  "recipeDishNumber": "porciju-skaits",
  "recipeDishNumber/1": "porciju-skaits/1",
  "recipeDishNumber/2": "porciju-skaits/2",
  "recipeDishNumber/3": "porciju-skaits/3",
  "recipeDishNumber/4": "porciju-skaits/4",
  "recipeDishNumber/5": "porciju-skaits/5",
  "recipeDishNumber/6": "porciju-skaits/6",
  "recipeDishNumber/7": "porciju-skaits/7",
  "recipeDishNumber/8": "porciju-skaits/8",
  "productTheme": "produkta-tema",
  "productTheme/ACC": "produkta-tema/piedevas",
  "productTheme/BEA": "produkta-tema/pupinas",
  "productTheme/BIS": "produkta-tema/pupinas-merce",
  "productTheme/BIO": "produkta-tema/eco",
  "productTheme/CAN": "produkta-tema/konservets",
  "productTheme/CER": "produkta-tema",
  "productTheme/CLS": "produkta-tema/klasisks",
  "productTheme/DLE": "produkta-tema/darzeni",
  "productTheme/EDR": "produkta-tema/edienu-draugs",
  "productTheme/ENT": "produkta-tema/uzkodas",
  "productTheme/FRZ": "produkta-tema/saldets",
  "productTheme/FSD": "produkta-tema/salati-mix",
  "productTheme/FSH": "produkta-tema/cena",
  "productTheme/ING": "produkta-tema/sastavdalas-manai-receptei",
  "productTheme/JAR": "produkta-tema/darzeni-burka",
  "productTheme/LBW": "produkta-tema",
  "productTheme/LDF": "produkta-tema/darzeni-cepsanai",
  "productTheme/LEG": "produkta-tema",
  "productTheme/LGO": "produkta-tema/darzeni",
  "productTheme/LGR": "produkta-tema/grileti-darzeni",
  "productTheme/LGS": "produkta-tema",
  "productTheme/MAI": "produkta-tema/majoneze",
  "productTheme/MUS": "produkta-tema/sampinjons",
  "productTheme/NEW": "produkta-tema/jaunumi",
  "productTheme/PDH": "produkta-tema/dry-vegetable-kitchen-dishes",
  "productTheme/PDL": "produkta-tema/basket-of-vegetables",
  "productTheme/PHR": "produkta-tema/pasta-and-pasta",
  "productTheme/PLP": "produkta-tema/pamatedieniem",
  "productTheme/RAL": "produkta-tema/risu-darzeni",
  "productTheme/RDM": "produkta-tema/ediens",
  "productTheme/SAL": "produkta-tema/viss-maniem-salatiem",
  "productTheme/SDB": "produkta-tema/salati-edieniem",
  "productTheme/SNK": "produkta-tema/uzkodas",
  "productTheme/SUP": "produkta-tema/zupas",
  "productTheme/TEX": "produkta-tema/tex-mex",
  "productTheme/VGP": "produkta-tema/darzenu-olbaltumvielas",
  "recipeTheme": "recepsu-tema",
  "recipeTheme/01": "recepsu-tema/vakarinu-edieni",
  "recipeTheme/02": "recepsu-tema/uzkodas",
  "recipeTheme/03": "recepsu-tema/salati-un-uzkodas",
  "recipeTheme/04": "recepsu-tema/zupas",
  "recipeTheme/05": "recepsu-tema/kukas",
  "recipeTheme/06": "recepsu-tema/berniem",
  "recipeTheme/07": "recepsu-tema/deserts",
  "recipeTheme/08": "recepsu-tema/vegetars",
  "recipeTheme/09": "recepsu-tema/piederumi",
  "recipeTheme/10": "recepsu-tema/lidznemsanai",
  "recipeTheme/11": "recepsu-tema/mijotes",
  "recipeTheme/12": "recepsu-tema/salati-un-barbeque",
  "recipeTheme/13": "recepsu-tema/salati-un-uzkodas",
  "recipeTheme/14": "recepsu-tema/pamatedieniem",
  "recipeTheme/15": "recepsu-tema/deserts-un-sacepumi",
  "recipeTheme/16": "recepsu-tema/uzkodas-un-zupas",
  "recipeTheme/17": "recepsu-tema/salati",
  "recipeTheme/18": "recepsu-tema/blodina",
  "recipeTheme/19": "recepsu-tema/zupas",
  "recipeTheme/20": "recepsu-tema/uzkodas",
  "recipeTheme/21": "recepsu-tema/merce",
  "recipeTheme/22": "recepsu-tema/viens-ediens",
  "recipeTheme/23": "recepsu-tema/citi-ediens",
  "recipeTheme/24": "recepsu-tema/ediens-cetram-personam",
  "recipeTheme/25": "recepsu-tema",
  "recipeTheme/26": "recepsu-tema",
  "recipeTheme/27": "recepsu-tema",
  "recipeTheme/28": "recepsu-tema",
  "recipeTheme/33": "recepsu-tema",
  "recipeTheme/34": "recepsu-tema",
  "recipeTheme/35": "recepsu-tema",
  "recipeTheme/36": "recepsu-tema",
  "recipeTheme/37": "recepsu-tema",
  "recipeTheme/38": "recepsu-tema",
  "recipeTheme/39": "recepsu-tema",
  "recipeTheme/40": "recepsu-tema",
  "recipeTheme/41": "recepsu-tema",
  "recipeTheme/42": "recepsu-tema",
  "recipeTheme/43": "recepsu-tema",
  "recipeTheme/44": "recepsu-tema",
  "recipeTheme/45": "recepsu-tema",
  "recipeTheme/46": "recepsu-tema",
  "pred-particularite": "toidu-eripara",
  "pred-particularite/Sans%20conservateur": "partikas-prieksrocibas/bez-konservantiem",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "partikas-prieksrocibas",
  "pred-particularite/Sans%20colorant": "partikas-prieksrocibas/bez-krasvielam",
  "pred-particularite/Sans%20sucre%20ajout%E9": "partikas-prieksrocibas/bez-pievienota-cukura",
  "pred-particularite/Sans%20sel%20ajout%E9": "partikas-prieksrocibas/bez-pievienota-sals",
  "pred-particularite/Sans%20additif": "partikas-prieksrocibas/bez-piedevam",
  "pred-particularite/": "partikas-prieksrocibas/bez-pievienota-sals",
  "pred-particularite/Sans%20lactose": "partikas-prieksrocibas/bez-laktozes",
  "pred-particularite/Sans%20gluten": "partikas-prieksrocibas/bez-glutena",
  "pred-particularite/V%E9g%E9tarien": "partikas-prieksrocibas/vegetars",
  "pred-particularite/V%E9g%E9talien": "partikas-prieksrocibas/veganisks",
  "pred-particularite/Sans%20sulfite": "partikas-prieksrocibas",
  "pred-particularite/A%20la%20vapeur": "partikas-prieksrocibas",
  "pred-particularite/Sans%20condiment": "partikas-prieksrocibas",
  "cultureType": "kulturas-veids",
  "cultureType/Bio": "kulturas-veids/eco",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "kulturas-veids/bez-pasticidiem",
  "cultureType/Sans%20OGM": "kulturas-veids/bez-gmo",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "toidu-eripara/veganisks",
  "pred-particularite/recipeVeggie": "toidu-eripara/vegetars",
  "pred-particularite/recipeGlutenfree": "toidu-eripara/bez-glutena",
  "pred-particularite/recipeLactosefree": "toidu-eripara/bez-laktozes"
};
